import React, { useState, useRef, useEffect } from 'react';
import './FormFieldsStyle.css';

const DynamicInputField = (props) => {
    const [value, setValue] = useState((props.userInputObj && props.userInputObj.key1) || "");
    const textareaRef = useRef(null);

    // Auto-resize logic
    useEffect(() => {
        if (textareaRef.current) {
            textareaRef.current.style.height = 'auto';
            textareaRef.current.style.height = `${Math.min(
                textareaRef.current.scrollHeight,
                props.maxRows * 24 // Assuming ~24px per line
            )}px`;
        }
    }, [value, props.maxRows]);

    const handleChange = (e) => {
        const newValue = e.target.value;
        setValue(newValue);

        // Handle any other onChange logic from props
        if (props.onChange) {
            props.onChange(e);
        }

        // Update errors and storage
        props?.setErrors((prevErrors) => ({
            ...prevErrors,
            [props?.index]: { key1: newValue, displayName: newValue },
        }));
        localStorage.setItem("inputValue", JSON.stringify({ key1: newValue }));
    };

    return (
        <div className="form-group">
            <label className="sel" style={{ fontSize: "16px", color: "#444444" }}>
                <span className="asterisk-icon"></span>
            </label>
            <textarea
                ref={textareaRef}
                className={`form-control dynamic-input error-${props?.index}`}
                placeholder={props.placeholder}
                value={value}
                onChange={handleChange}
                rows={props.minRows || 1}
                style={{
                    marginLeft: '6px',
                    resize: 'none',
                    overflowY: 'hidden',
                    minHeight: '38px' // Single line height
                }}
            />
        </div>
    );
};

export default DynamicInputField;